module.exports = __webpack_public_path__ + "img/testing-bg.67d3b549.svg";